import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { endOfDay } from '../../../clientServices/QueueService';
import './modal.css';

const InitQueuesModal = ({ open, handleClose, onConfirm ,initSystem }) => {

    const handleConfirmInitQueues = async () => {
        try {
            await endOfDay();
            alert('הנתונים אופסו בהצלחה');
            onConfirm(); // Use the onConfirm prop to handle closing or any action after confirmation
            initSystem();
        } catch (error) {
            console.error("Error during end of day:", error);
            alert('Error occurred while resetting the data');
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} dir="rtl"> {/* Setting direction to RTL */}
            <DialogTitle style={{ textAlign: 'right' }}>אתחול תורים</DialogTitle> {/* Aligning title to the right */}
            <DialogContent style={{ textAlign: 'right' }}>
                האם אתה בטוח שברצונך לאתחל את כל התורים ולמחוק את הנתונים?
            </DialogContent>
            <DialogActions style={{ justifyContent: 'flex-start' }}> {/* Aligning actions to the right */}
                <Button onClick={handleClose} color="primary">
                    ביטול
                </Button>
                <Button onClick={handleConfirmInitQueues} color="secondary">
                    אישור
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InitQueuesModal;
